export default "__VITE_ASSET__COsij9cz__"